import React, { useState } from "react";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import cancel from "../assets/images/navbar/cancel.png";
import arrowRight from "../assets/images/location-modal/arrow-right.png";
import scooter from "../assets/images/navbar/scooter.png";
import userHelp from "../assets/images/navbar/user-help.png";
import chart from "../assets/images/navbar/chart-line.png";
import invoice from "../assets/images/navbar/invoice.png";
import taxes from "../assets/images/navbar/taxes.png";
import kitchen from "../assets/images/navbar/kitchen.png";
import file from "../assets/images/navbar/sales.png";
import addressLocation from "../assets/images/navbar/address-location.png";
import { FAQ_DATA } from "../data/staticContent";

type HelpAndSupportProps = {
  setIsHelpAndSupportOpen: (open: boolean) => void;
};

const HelpAndSupport = ({ setIsHelpAndSupportOpen }: HelpAndSupportProps) => {
  const [selectedTopic, setSelectedTopic] = useState<string | null>(null);

  const helpTopics = [
    { id: 1, icon: scooter, label: "Order Related issues" },
    { id: 2, icon: kitchen, label: "Restaurant" },
    { id: 3, icon: file, label: "Menu" },
    { id: 4, icon: chart, label: "Business growth" },
    { id: 5, icon: invoice, label: "Payments" },
    { id: 6, icon: taxes, label: "Taxes" },
    { id: 7, icon: userHelp, label: "Hygiene and health" },
    { id: 8, icon: addressLocation, label: "Location and address" },
  ];

  const articles = selectedTopic
    ? FAQ_DATA.filter((item) => item.topic === selectedTopic)
    : [];

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[60]"
      onClick={() => setIsHelpAndSupportOpen(false)}
    >
      <div
        className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-900 rounded-l-[20px] overflow-y-auto flex flex-col"
        style={{ animation: "slideInRight 0.3s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white dark:bg-gray-900 z-10 px-6 py-4 border-b dark:border-gray-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src={arrowLeft}
                alt="back"
                className="w-[36px] h-[36px] p-[7.5px] rounded-full border cursor-pointer"
                onClick={() =>
                  selectedTopic ? setSelectedTopic(null) : setIsHelpAndSupportOpen(false)
                }
              />
              <h2 className="text-[#040404] dark:text-gray-200 font-Urbanist text-[20px] font-semibold">
                {selectedTopic || "Help Center"}
              </h2>
            </div>
            <img
              src={cancel}
              alt="close"
              className="w-[36px] h-[36px] p-[7.5px] rounded-full border cursor-pointer"
              onClick={() => setIsHelpAndSupportOpen(false)}
            />
          </div>
        </div>

        <div className="flex-1 px-6 py-4">
          {!selectedTopic ? (
            <div className="space-y-3">
              {helpTopics.map((topic) => (
                <div
                  key={topic.id}
                  onClick={() => setSelectedTopic(topic.label)}
                  className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-[12px] hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                >
                  <div className="flex items-center gap-3">
                    <img src={topic.icon} alt={topic.label} className="h-[20px] w-[20px] dark:invert" />
                    <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-[16px]">
                      {topic.label}
                    </span>
                  </div>
                  <img src={arrowRight} alt="arrow" className="w-5 h-5 dark:invert" />
                </div>
              ))}
            </div>
          ) : articles.length === 0 ? (
            <p className="text-gray-500">
              No articles for this topic yet. Try FAQs from the Help menu for more answers.
            </p>
          ) : (
            <div className="space-y-4">
              {articles.map((article) => (
                <div key={article.id} className="border dark:border-gray-700 rounded-xl p-4">
                  <h3 className="font-semibold text-[#050505] dark:text-gray-200 mb-2">
                    {article.question}
                  </h3>
                  <p className="text-sm text-[#6A6A6A] dark:text-gray-400">{article.answer}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpAndSupport;
